import { SyntheticEvent } from 'react';
import TextField from '@mui/material/TextField';

import BatchList from '#components/BatchList';
import { EDIT_PANEL_EVENT_TYPE } from '#common/constants/addons';

type BatchRow = Record<string, string>;

interface BatchListError {
  rowIndex: number;
  [field: string]: unknown;
}

interface ShippingWindowProps {
  name?: string;
  value: BatchRow[];
  onChange: (event: SyntheticEvent, change: { name?: string | undefined; value: BatchRow[] }) => void;
  sizes: number[];
  controlVisibility?: string[] | undefined;
  errors?: BatchListError[] | undefined;
  errorMessages?: BatchListError[] | undefined;
  editType?: string;
}

export default function ShippingWindow(props: ShippingWindowProps) {
  const {
    name,
    value,
    onChange,
    sizes,
    controlVisibility,
    errors,
    errorMessages,
    editType,
  } = props;

  return (
    <BatchList
      items={value}
      name={name}
      onChange={onChange}
      sizes={sizes}
      errors={errors}
      errorMessages={errorMessages}
      controlVisibility={controlVisibility}
    >
      {(!controlVisibility || controlVisibility.includes('name'))
      && (
      <TextField
        fullWidth
        data-testid="name"
        size="small"
        name="name"
        label={editType
          ? editType === EDIT_PANEL_EVENT_TYPE.ADD ? 'Name' : 'Name (Find)'
          : 'Name'}
        variant="outlined"
      />
      )}
      {(!controlVisibility || controlVisibility.includes('weeks'))
      && (
      <TextField
        data-testid="weeks"
        size="small"
        type="number"
        name="weeks"
        label={editType
          ? editType === EDIT_PANEL_EVENT_TYPE.ADD ? 'Weeks' : 'Weeks (Replace)'
          : 'Weeks'}
        variant="outlined"
      />
      )}
      {(!controlVisibility || controlVisibility.includes('price'))
      && (
      <TextField
        data-testid="price"
        size="small"
        type="number"
        name="price"
        label={editType ? editType === EDIT_PANEL_EVENT_TYPE.ADD ? 'Price' : 'Price (Replace)'
          : 'Price'}
        variant="outlined"
      />
      )}
    </BatchList>
  );
}
